import { requireAdminPage } from '@/lib/admin-auth'
import { ShopsScreen } from './shops-screen'

export const dynamic = 'force-dynamic'

export default async function ShopsPage() {
  await requireAdminPage()

  return <ShopsScreen />
}
